import React from 'react';
import IconButton from './IconButton';

const DownloadButton = ({
  disabled,
  href,
  loading,
  onClick,
  positive,
}) => (
  <IconButton
    className="aridhia-download-button"
    disabled={disabled}
    href={href}
    icon
    iconName="download"
    loading={loading}
    messageId="actions.download"
    onClick={onClick}
    positive={positive}
  />
);

export default DownloadButton;
